// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__fg72k","g120":"MainLayout_g120__w3sRV","fullHeight":"MainLayout_fullHeight__bq3bd"};